import { mobileAppVersionCheck } from "./api/userService";
import { Config } from "./config";
import { mobileAppInfo } from "./mobileHelper";
import { DevicePlatform, MobileAppVersion } from "./types";
import { openUrl } from "./urlHelper";

export enum PromptButton {
  NextTime = "Next time",
  Update = "Update"
}

const promptButtons = [PromptButton.NextTime, PromptButton.Update];

const isUpdate = (buttonType: PromptButton) => {
  return buttonType === PromptButton.Update;
};

const iOS = () => {
  return mobileAppInfo().platform === DevicePlatform.iOS;
};

const android = () => {
  return mobileAppInfo().platform === DevicePlatform.Android;
};

const getAppStoreUrl = (response: MobileAppVersion): string => {
  if (android()) {
    return response.googlePlayStoreUrl;
  }
  if (iOS()) {
    return response.appleStoreUrl;
  }
  return "";
};

const onDeviceReady = () => {
  if (Config.Mobile.AppId) {
    mobileAppVersionCheck(Config.Mobile.AppId).then(response => {
      if (Config.Mobile.AppVersion < response.data.minimumSuggested) {
        openPrompt(getAppStoreUrl(response.data));
      }
    }).catch(_ => {/** ignore */} );
  }
};

const onButtonPressed = (buttonType: PromptButton, appStoreUrl: string) => {
  if (isUpdate(buttonType)) {
    openUrl(appStoreUrl);
  }
};

const openPrompt = (appStoreUrl: string) => {
  (window as any)
    .navigator
    .notification
    .confirm(`A new version of ${mobileAppInfo().name} is now available. We recommend you update the app to receive the latest enhancements and bug fixes.`,
    button => onButtonPressed(promptButtons[button - 1], appStoreUrl), // button value is not an array index so substracting 1 to get the correct index value
    "Update Available",
    promptButtons
  );
};

document.addEventListener("deviceReady", onDeviceReady, false);